import { useNavigate } from 'react-router-dom';
import '../App.css';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, Typography, Box } from '@mui/material';

const SelectOrganization = () => {
  const navigate = useNavigate();

  const onSelectOrganization = (event: SelectChangeEvent<string>) => {
    navigate(`/${event.target.value}/form`);
  };

  return (
    <div className="flex h-full justify-center items-center flex-col gap-8">
      <Box component="section" sx={{ textAlign: 'center' }}>
        <Typography variant="h6"> Welcome!</Typography>
        <Typography variant="body1"> To start the process, please select your organization </Typography>
      </Box>
      <FormControl sx={{ m: 2, maxWidth: 500, minWidth: 120, width: '90%', justifyContent: 'center' }} size="medium">
        <InputLabel>Select Organization</InputLabel>
        <Select defaultValue={''} sx={{ textAlign: 'center' }} label="Select Organization" onChange={(e) => onSelectOrganization(e)}>
          <MenuItem value={'NY'}>New York</MenuItem>
          <MenuItem value={'NJ'}>New Jersey</MenuItem>
          <MenuItem value={'CT'}>Connecticut</MenuItem>
          <MenuItem value={'IL'}>Illinois</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};
export default SelectOrganization;
